// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-container[data-v-7bddcbc6]{height:126px}.header-container .top-nav[data-v-7bddcbc6]{height:126px;padding:0 32px;background:#fff}.header-container .cor-border[data-v-7bddcbc6]{width:100%;height:11px;background:linear-gradient(90deg,#ffcf92,#ff6060)}", ""]);
// Exports
module.exports = exports;
